import React from 'react'
import { Container } from './Sidebar.styles'
import SidebarProps from './Sidebar.types'

const Sidebar: React.FC<SidebarProps> = ({ children, zindex }) => {
  return <Container zindex={zindex}>{children}</Container>
}

export default Sidebar
